import { connect } from 'react-redux'
import { compose, withProps, withHandlers } from 'recompose'
import Location from 'components/common/Location'
import withClientGeoLocation from 'components/common/hoc/withClientGeoLocation'
import { submitSearchStoreFormAction, showStoreLocatorModal } from 'actions/storeLocator'
import googleMapRouteUrl from 'helpers/google-map-route-url'

const mapStateToProps = ({ myStore: selectedStore }) => ({ selectedStore })

const withStoreLocatorProps = withProps(({ selectedStore, coords }) => {
  const { latitude, longitude } = coords || {}
  const { address } = selectedStore || {}

  return {
    isMyAccount: true,
    buttonText: 'Find My Store',
    routeToLocationUrl: googleMapRouteUrl({
      from: latitude && longitude ? { latitude, longitude } : false,
      to: address
    })
  }
})

const withStoreLocatorHandlers = withHandlers({
  handleEditClick: ({ showStoreLocatorModal }) => () => showStoreLocatorModal()
})

export default compose(
  connect(mapStateToProps, { showStoreLocatorModal, findStoreHandleSubmit: submitSearchStoreFormAction }),
  withClientGeoLocation,
  withStoreLocatorHandlers,
  withStoreLocatorProps
)(Location)
